import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";


export const useCreateConsultation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (consultation: FormData) => {
      return api.post("report/", consultation, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.patient(
          variables.get("patient_id") as string
        ),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.get("patient_id") as string),
      });
    },

    onError: (res, variables) => {
      console.error("[From Create Consultation]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.patient(
          variables.get("patient_id") as string
        ),
      });
    },
  });
};
